import { isSearchConfluencePartial } from '@atlassian/search-client';

import type { IAnalyticsSearchPageResults } from '../../../common/types';

/**
 * @returns
 * numberOfSocialSignalsShown: Number - The number of search results that contain a social signal
 * numberOfSocialSignalsShownTop10: Number - The number of search results that contain a social signal in the top 10
 * socialSignalSearchResultPositions: Array - Contains the positions of search results that contain a social signal
 */
export const useSocialSignalsAnalyticsAttributes: (relayResults?: IAnalyticsSearchPageResults) => {
	numberOfSocialSignalsShown: number;
	numberOfSocialSignalsShownTop10: number;
	socialSignalSearchResultPositions: number[];
} = (relayResults?: IAnalyticsSearchPageResults) => {
	return {
		numberOfSocialSignalsShown: countSocialSignalsShown(relayResults),
		numberOfSocialSignalsShownTop10: countSocialSignalsShownTop10(relayResults),
		socialSignalSearchResultPositions: getSocialSignalSearchResultPositions(relayResults),
	};
};

const countSocialSignalsShown = (results?: IAnalyticsSearchPageResults) =>
	results?.edges.filter(({ node }) => isSearchConfluencePartial(node) && node.socialSignal)
		.length || 0;

const countSocialSignalsShownTop10 = (results?: IAnalyticsSearchPageResults) =>
	results?.edges
		.slice(0, 10)
		.filter(({ node }) => isSearchConfluencePartial(node) && node.socialSignal).length || 0;

const getSocialSignalSearchResultPositions = (results?: IAnalyticsSearchPageResults) =>
	results?.edges.reduce((acc: number[], { node }, index) => {
		if (isSearchConfluencePartial(node) && node.socialSignal) {
			acc.push(index + 1);
		}
		return acc;
	}, []) || [];
